import React from 'react';
import { Box } from '@chakra-ui/react';

import Heading from './components/heading/Heading';
import Main from './components/main/Main';

const App = () => {
  return (
    <Box>
      <Heading />
      <Main />
    </Box>
  );
};

export default App;
